import { getPreviousDate, stringToDate } from "@ui-seeker/utils"

import { DATE_PERIODS } from "@constants"
import { sellerDeepDiveEndDate, sellerDeepDiveOffersCurrentPeriod } from "../@signals"


export const rangeDatesShareMbl = [
    {
        label: 'Yesterday',
        value: () => { return [getPreviousDate({ days: 1 }, sellerDeepDiveEndDate.value), getPreviousDate({ days: 1 }, sellerDeepDiveEndDate.value)] },
        placement: 'left',
        onFocus: () => sellerDeepDiveOffersCurrentPeriod.value = DATE_PERIODS.YESTERDAY
    }, {
        label: 'Last 7 Days',
        value: () => { return [getPreviousDate({ days: 6 }, sellerDeepDiveEndDate.value), stringToDate(sellerDeepDiveEndDate.value)] },
        placement: 'left',
        onFocus: () => sellerDeepDiveOffersCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS
    }, {
        label: 'Last 30 Days',
        value: () => { return [getPreviousDate({ days: 29 }, sellerDeepDiveEndDate.value), stringToDate(sellerDeepDiveEndDate.value)] },
        placement: 'left',
        onFocus: () => sellerDeepDiveOffersCurrentPeriod.value = DATE_PERIODS.LAST_30_DAYS
    }, {
        label: 'Last Month',
        value: () => {
            return [
                getPreviousDate({ months: 1 }, new Date(stringToDate(sellerDeepDiveEndDate.value).setDate(1))),
                getPreviousDate({ days: 1 },  new Date(stringToDate(sellerDeepDiveEndDate.value).setDate(1)))
            ]
        },
        placement: 'left',
        onFocus: () => sellerDeepDiveOffersCurrentPeriod.value = DATE_PERIODS.LAST_MONTH
    }
]